import { render, staticRenderFns } from "./BaseCreateDialog.vue?vue&type=template&id=6e10fbc6&"
import script from "./BaseCreateDialog.vue?vue&type=script&lang=js&"
export * from "./BaseCreateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports